<template>
  <div class="vx-row">
    <div class="vx-col md:w-1/1 w-full">
      <vs-input class="w-full mt-4" label="Nome" v-model="data.name" name="name" autofocus />

      <vs-input class="w-full mt-4" label="E-mail" v-model="data.email" name="email" type="email" />

      <vs-checkbox class="mt-4" v-model="data.active" vs-value="1"> Ativo</vs-checkbox>

      <vs-input class="w-full mt-4" label="Senha (deixe em branco para não alterar)" v-model="data.password" name="password" type="password" />

      <vs-input class="w-full mt-4" label="Confirmação da senha  (deixe em branco para não alterar)" v-model="data.password_confirmation" name="confirmation_password" type="password" />

      <div class="vx-row">
        <div class="vx-col md:w-6/12 w-full text-center">
          <vs-button class="mt-4" icon-pack="feather" icon="icon icon-file" @click="save">Salvar</vs-button>
        </div>
        <div class="vx-col md:w-6/12 w-full text-right">
          <vs-button class="mt-4" icon-pack="feather" color="danger" @click="$router.push('/usuarios')">Cancelar</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      plans: [],
      data: {
        name: null,
        email: null,
        active: null,
        password: null,
        password_confirmation: null,
      },
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      if (parseInt(this.$route.params.id) > 0) {
        this.$api
        .get(`/api/v1/backend/users/${this.$route.params.id}`)
        .then((response) => {
          this.$vs.loading.close()
          this.data = response.data
        })
        .catch((error) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Erro',
            text: error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
      }
    },
    save() {
      this.$vs.loading()

      this.$api({
        method: this.$route.params.id ? 'PATCH' : 'POST',
        url: this.$route.params.id ? `/api/v1/backend/users/${this.$route.params.id}` : '/api/v1/backend/users',
        data: this.data
      })
      .then((response) => {
        this.$vs.loading.close()
        this.data = response.data

        this.$vs.notify({
          text: 'Salvo',
          color: 'success'
        })

        this.$router.push('/usuarios')
      })
      .catch((error) => {
        this.$vs.loading.close()
        this.$vs.notify({
          title: 'Erro',
          text: Object.values(error.response.data.errors).join('<br>'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    },
  }
}
</script>
